import { useEffect, useRef, useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography,
  Container,
} from "@mui/material";
import { createApiCall } from "../api/api-service";

const ProductFormWithVariants = () => {
  let ecoms = [
    { ecom_name: "Amazon" },
    { ecom_name: "Flipkart" },
    { ecom_name: "Meesho" },
    { ecom_name: "Nykaa" },
    { ecom_name: "Sugar Cosmetics" },
    { ecom_name: "Colorbar Cosmetics" },
    { ecom_name: "Lakme India" },
  ];
  // Mocked dropdown options
  const fileInputRef = useRef();
  const [brands, setBrands] = useState([]);
  const [categories, setCategories] = useState([]);
  const fetch_category_list = async () => {
    const data = await createApiCall("GET", "inventory/fetch_category");
    setCategories(data);
  };
  const fetchBrandData = async () => {
    const data = await createApiCall("GET", "inventory/fetch_brands");
    setBrands(data);
  };
  useEffect(() => {
    fetch_category_list();
    fetchBrandData();
  }, []);

  const [formData, setFormData] = useState({
    brand: "",
    category: "",
    variantName: "",
    variantDesc: "",
    variantImage: "",
    productName: "",
    productId: "",
    prices: [],
  });

  const [priceEntry, setPriceEntry] = useState({
    ecommerceName: "",
    affiliateUrl: "",
    price: "",
  });

  const [products, setProducts] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePriceChange = (e) => {
    const { name, value } = e.target;
    setPriceEntry((prev) => ({ ...prev, [name]: value }));
  };

  const addPriceEntry = () => {
    if (
      priceEntry.ecommerceName &&
      priceEntry.affiliateUrl &&
      priceEntry.price
    ) {
      setFormData((prev) => ({
        ...prev,
        prices: [...prev.prices, priceEntry],
      }));
      setPriceEntry({ ecommerceName: "", affiliateUrl: "", price: "" });
    }
  };

  const addProduct = async () => {
    // const { brand, category, variantName, variantDesc, variantImage, prices } =
    //   formData;

    const formRequest = new FormData();
    formRequest.append("excel_file", file);
    formRequest.append("product_id", formData.productId);
    let brand_name = brands.find((val) => {
      return val?.brand_id == formData.brand;
    });
    formRequest.append("ecom_name", brand_name?.brand_name);

    const response = await createApiCall(
      "POST",
      "inventory/add_product_variant",
      formRequest,
      true,
      {
        "Content-Type": "multipart/form-data",
      }
    );

    if (response?.response === "000") {
      setStatus("Uploaded Successfully");
    }
    else{
      setStatus("Upload Failed")
    }
  };
  const createProduct = async () => {
    let data = await createApiCall("POST", "inventory/add_product", {
      brand_id: formData.brand,
      category_id: formData.category,
    });
    setFormData((prev) => ({ ...prev, productId: data.product_id }));
  };
  const [file, setFile] = useState("");
  const [status, setStatus] = useState("");
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && /\.(xls|xlsx)$/i.test(selectedFile.name)) {
      setFile(selectedFile);
      setStatus("");
    } else {
      setFile("");
      setStatus("Please upload a valid Excel file.");
    }
  };

  const Clear = () => {
    setFormData({
      brand: "",
      category: "",
      variantName: "",
      variantDesc: "",
      variantImage: "",
      productName: "",
      productId: "",
      prices: [],
    }); 
    setFile(null);
    fileInputRef.current.value = '';
    setStatus("")
  };

  return (
    <Container>
      <Box>
        <Typography variant="h6" gutterBottom>
          Add Product
        </Typography>

        <Grid container spacing={2}>
          <Grid item size={{ xs: "12" }}>
            <TextField
              select
              label="Brand"
              name="brand"
              value={formData.brand}
              size="medium"
              onChange={handleChange}
              fullWidth
            >
              {brands.map((brand) => (
                <MenuItem key={brand?.brand_id} value={brand?.brand_id}>
                  {brand?.brand_name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          <Grid item size={{ xs: "12" }}>
            <TextField
              select
              label="Category"
              name="category"
              value={formData.category}
              size="medium"
              onChange={handleChange}
              fullWidth
            >
              {categories.map((cat) => (
                <MenuItem key={cat?.category_id} value={cat?.category_id}>
                  {cat?.category_name}
                </MenuItem>
              ))}
            </TextField>
          </Grid>

          <Button
            onClick={createProduct}
            variant="contained"
            fullWidth
            disabled={formData.productId == "" ? false : true}
          >
            Add Product
          </Button>
        </Grid>
        <Grid container spacing={2}>
          <Grid>
            <Box sx={{ maxWidth: 400, mx: "auto", mt: 4, textAlign: "center" }}>
              <Typography variant="h6" gutterBottom>
                Upload Excel File
              </Typography>

              <input
                accept=".xls,.xlsx"
                type="file"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ marginBottom: "16px" }}
              />

              <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                <Button onClick={addProduct} variant="contained" fullWidth>
                  Add Variant
                </Button>
                <Button onClick={Clear} variant="contained" fullWidth>
                  Clear
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid>
            <Typography>{status}</Typography>
          </Grid>

          {/* <Grid item size ={{ xs:12, sm:4}}>
                        <TextField label="Variant Name" name="variantName" value={formData.variantName} onChange={handleChange} fullWidth />
                    </Grid>
                    <Grid item size ={{ xs:12, sm:4}}>
                        <TextField label="Variant Description" name="variantDesc" value={formData.variantDesc} onChange={handleChange} fullWidth />
                    </Grid>
                    <Grid item size ={{ xs:12, sm:4}}>
                        <TextField label="Variant Image URL" name="variantImage" value={formData.variantImage} onChange={handleChange} fullWidth />
                    </Grid> */}

          {/* Price Entries */}
          {/* <Grid item size ={{ xs:12, sm:4}}>
                        <TextField select label="Ecommerce Name" name="ecommerceName" value={priceEntry.ecommerceName} size='medium' onChange={handlePriceChange} fullWidth>
                            {ecoms.map((brand) => <MenuItem key={brand?.ecom_name} value={brand?.ecom_name}>{brand?.ecom_name}</MenuItem>)}
                        </TextField>

                    </Grid>
                    <Grid item size ={{ xs:12, sm:4}}>
                        <TextField label="Affiliate URL" name="affiliateUrl" value={priceEntry.affiliateUrl} onChange={handlePriceChange} fullWidth />
                    </Grid>
                    <Grid item size ={{xs:12, sm:3}}>
                        <TextField label="Price" name="price" value={priceEntry.price} onChange={handlePriceChange} fullWidth />
                    </Grid>
                    <Grid item size={{xs:12}} >
                        <Button onClick={addPriceEntry} variant="contained" fullWidth sx={{ mt: 1.5 }}>+</Button>
                    </Grid> */}

          {/* <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>ecommerceName</TableCell>
                                        <TableCell>AffiliateUrl</TableCell>
                                        <TableCell>Price</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {formData.prices.map((p, idx) => {
                                        return (<>
                                            <TableRow>
                                                <TableCell><strong>{p.ecommerceName}</strong> </TableCell>
                                                <TableCell> <a href={p.affiliateUrl} target="_blank" rel="noopener noreferrer">Link</a></TableCell>
                                                <TableCell><strong>{p.price}</strong> </TableCell>
                                            </TableRow>
                                        </>
                                        )
                                    })
                                    }
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Grid> */}
        </Grid>

        {/* Table */}
        {/* <Box mt={4}>
          <Typography variant="h6" gutterBottom>
            Products
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Brand</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Variant Name</TableCell>
                  <TableCell>Price Entries</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {products.map((product, i) => (
                  <TableRow key={i}>
                    <TableCell>{product.brand}</TableCell>
                    <TableCell>{product.category}</TableCell>
                    <TableCell>{product.variantName}</TableCell>
                    <TableCell>
                      {product.prices.map((p, idx) => (
                        <Box key={idx}>
                          <strong>{p.ecommerceName}</strong>: ${p.price} <br />
                          <a
                            href={p.affiliateUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Link
                          </a>
                        </Box>
                      ))}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box> */}
      </Box>
    </Container>
  );
};

export default ProductFormWithVariants;
